import React from 'react';
import TemplatePage from '../../../components/templatePage';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from '../../../../../@casino/useRouter';
import { setGetUserById } from '../../store/thunk/setGetUserById';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { setGetRezyme } from '../../store/thunk/setGetRezyme';
import { setLoadingAction } from '../../../components/templatePage/store/action';
import Navigation from '../../components/navigation';

const handleLoadPagination = ({page, setPage, countPage, dispatch, id}) => {
    if (page <= countPage) {
        dispatch(setGetRezyme({
            page: page + 1,
            rowsPerPage: 10,
            id
        }));
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const useStyles = makeStyles(() => ({
    wrapBlock: {
        padding: '0 20px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 5
    },
}))

const ReportGames = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const classes = useStyles();
    const {id} = router.query;

    const [page, setPage] = React.useState(1);
    const [isShowNavigation, setIsShowNavigation] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetUserById(id))
        dispatch(setGetRezyme({
            id,
            page: 1,
            rowsPerPage: 10
        }))
    }, [id])

    const view = useSelector(state => state.usersMobile.view);
    const list = useSelector(state => state.usersMobile.rezyme);

    const BlockItem = ({title, amount}) => {
        return (
            <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center', marginBottom: 8}}>
                <span style={{
                    color: 'hsla(0,0%,100%,.5)',
                    fontSize: '14px',
                    fontFamily: 'PT-sans, sans-serif',
                    paddingBottom: 8
                }}>{title}:</span>
                <span
                    style={{
                        color: '#fff',
                        fontSize: 14,
                        fontFamily: 'PT-sans, sans-serif', 
                    }}
                >
                    {amount}
                </span>
            </div>
        )
    }

    const GameItem = ({item}) => {
        const {game, sum, sum_win, count} = item;
        return (
            <div className={classes.wrapBlock} style={{borderBottom: '2px solid rgb(20, 27, 51)', marginBottom: 12}}>
                <div className={classes.w50}>
                    <BlockItem title="Название" amount={game} />
                    <BlockItem title="Сумма ставок" amount={new Intl.NumberFormat('ru-RU').format(sum ? sum.toFixed(2) : sum)} />
                    <BlockItem title="Количество" amount={new Intl.NumberFormat('ru-RU').format(+count ? (+count).toFixed(2) : +count)} />
                </div>
                <div style={{width: '50%'}}>
                    <BlockItem title="RTP" amount={`${(sum_win/sum*100).toFixed()}%`} />
                    <BlockItem title="Сумма выигрышей" amount={new Intl.NumberFormat('ru-RU').format(sum_win ? sum_win.toFixed(2) : sum_win)} />
                    <BlockItem title="Разница" amount={new Intl.NumberFormat('ru-RU').format((sum - sum_win) ? (sum - sum_win).toFixed(2) : sum - sum_win)} />
                </div>
            </div> 
        )
    }

    return (
        <TemplatePage
            title={`Отчет по играм (${view.login ? view.login : ''})`}
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage,
                dispatch,
                id
            })}
            handleLoading={() => handleLoading(dispatch)}
        >
             <div style={{width: 'calc(100% - 20px)', marginTop: 12}}>
             <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', columnGap: 10, marginBottom: 12}}>
                    <span 
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            border: '1px solid #ffce01',
                            cursor: 'pointer',
                            outline: 'none',
                            padding: '5px 0',
                            background: '#ffce01',
                            borderRadius: '12px',
                            color: '#24263e',
                            fontSize: 14,
                            fontWeight: 700,
                            width: '100%'
                        }}
                        onClick={() => {
                            setIsShowNavigation(true)
                        }}
                    >Дополнительно</span>
                </div>
                <div style={{width: '100%'}}> 
                    {
                        list.data.map((item) => <GameItem item={item} />)
                    }
                </div> 
            </div>
            <Navigation isShowNavigation={isShowNavigation} setIsShowNavigation={setIsShowNavigation} id={id}  profile={view}/>
        </TemplatePage>
    )
}

export default ReportGames;